import * as data from '@/data/data.json'

import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

export interface State {
	data: any
	currentScreen: number
	onAnswerScreen: boolean
	userOnResultScreen: boolean
	userChoices: any[]
	randomizedOptions: any[]
	formInputValues: { [key: number]: { questionId: number, answers: { [key: string]: string } } }
	visitedQuestions: number[]
}

const state: State = {
	data: data.default,
	currentScreen: 0,
	onAnswerScreen: false,
	userOnResultScreen: false,
	userChoices: [],
	randomizedOptions: [],
	formInputValues: [],
	visitedQuestions: []
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
